module.exports = __webpack_public_path__ + "static/media/white-back-arrow.901ded01.svg";